import { useMemo } from 'react';
import { usePostHog } from 'posthog-js/react';
import { PostHogInstance } from 'shared/posthogCapture/types';

export const createPwaCaptureEvents = (posthog: PostHogInstance) => ({
  installHintShown: () => {
    posthog?.capture('pwa / install hint / shown');
  },
  installHintDismissed: () => {
    posthog?.capture('pwa / install hint / dismissed');
  },
  launchedStandalone: () => {
    posthog?.capture('pwa / app / launched standalone');
  },
  pushEnabled: () => {
    posthog?.capture('pwa / push / enabled');
  },
  pushDisabled: () => {
    posthog?.capture('pwa / push / disabled');
  },
  pushBlocked: () => {
    posthog?.capture('pwa / push / blocked');
  },
});

export type PwaCaptureEvents = ReturnType<typeof createPwaCaptureEvents>;

export const usePosthogCapture = () => {
  const posthog = usePostHog();
  return useMemo(() => createPwaCaptureEvents(posthog), [posthog]);
};
